'use strict';
import * as $j_com$002eraquo$002eew$002e$002dJs$002dArray$0024$002dRich$002dJs$002dArray$0024 from "./com.raquo.ew.-Js-Array$-Rich-Js-Array$.js";
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
import * as $j_scala$002escalajs$002ejs$002e$002dAny$0024 from "./scala.scalajs.js.-Any$.js";
var $p;
/** @constructor */
function $c_Lcom_raquo_laminar_Seq(seq, scalaArray, jsArray) {
  this.yY = null;
  this.Fo = null;
  this.yX = null;
  this.yY = seq;
  this.Fo = scalaArray;
  this.yX = jsArray;
}
export { $c_Lcom_raquo_laminar_Seq as $c_Lcom_raquo_laminar_Seq };
$p = $c_Lcom_raquo_laminar_Seq.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Lcom_raquo_laminar_Seq;
/** @constructor */
function $h_Lcom_raquo_laminar_Seq() {
}
export { $h_Lcom_raquo_laminar_Seq as $h_Lcom_raquo_laminar_Seq };
$h_Lcom_raquo_laminar_Seq.prototype = $p;
$p.a6 = (function(f) {
  if ((this.yY !== null)) {
    this.yY.a6(f);
  } else if ((this.yX !== null)) {
    $j_com$002eraquo$002eew$002e$002dJs$002dArray$0024$002dRich$002dJs$002dArray$0024.$m_Lcom_raquo_ew_JsArray$RichJsArray$().U2(this.yX, $j_scala$002escalajs$002ejs$002e$002dAny$0024.$m_sjs_js_Any$().Ui(f));
  } else {
    $j_java$002elang$002e$002dObject.$m_sc_ArrayOps$().U4(this.Fo, f);
  }
});
var $d_Lcom_raquo_laminar_Seq = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lcom_raquo_laminar_Seq, "com.raquo.laminar.Seq", ({
  hv: 1
}));
export { $d_Lcom_raquo_laminar_Seq as $d_Lcom_raquo_laminar_Seq };
